"use client";

import { usePathname } from "next/navigation";

import { PopupConfig } from "./Popup.types";
import { popupMatchesPath } from "./Popup.utils";
import PopupInstance from "./PopupInstance.component";
import { useGlobalContext } from "@/lib/globalContext";

export default function Popup() {
  const { themeOptions } = useGlobalContext();
  const popups = (themeOptions?.popups as PopupConfig[] | undefined) || [];
  const pathname = usePathname();

  if (!popups.length) return null;

  // Popups are ordered by menu order/date from the backend. When more than one
  // targets the current page, show the first match to avoid stacking modals.
  const match = popups.find((popup) => popupMatchesPath(popup, pathname));

  if (!match) return null;

  return <PopupInstance key={match.id ?? "default"} popup={match} />;
}
